import styled from "@emotion/styled";
import { InputNumber, Select } from "antd";

export const BinarySelect = styled(Select)`
  width: 100%;
`;

export const CompactInput = styled(InputNumber)`
  width: 100%;
`;

export const CompactSelect = styled(Select)`
  width: 100%;
`;
